import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(document.querySelector("#root"));
root.render(<App />);

// ![Wordle_React drawio](https://user-images.githubusercontent.com/105493144/171645437-97d83e9e-f440-4941-b713-5353206793ef.png)
